import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Models } from '@ibexfusion/models';
import { OrganisationService } from '@services/organisations/organisation.service';
import { RoleService } from '@services/roles/role.service';
import { DataTableEvent } from '../../../../components/data-table/data-table.component';

@Component({
    selector: 'app-group-role-selection',
    templateUrl: './group-role-selection.component.html',
    styleUrls: ['./group-role-selection.component.scss'],
    providers: [RoleService, OrganisationService],
    standalone: false
})
export class GroupRoleSelectionComponent implements OnInit {

  @ViewChild('hStepper') stepper: MatStepper;

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;

  selectedRoleId: string;
  boundRole: Models.Role;
  selectedOrganisationId: string;
  boundOrganisation: Models.Organisation;

  constructor(
    public dialogRef: MatDialogRef<GroupRoleSelectionComponent>,
    public roleService: RoleService,
    public organisationService: OrganisationService,
    private formBuilder: UntypedFormBuilder
  ) {
  }

  ngOnInit() {
    this.firstFormGroup = this.formBuilder.group({
      roleId: ['', Validators.required]
    });
    this.secondFormGroup = this.formBuilder.group({
      organisationId: ['', Validators.required]
    });
  }

  selectRole(event: DataTableEvent) {
    this.selectedRoleId = event.row.RoleID;
    this.roleService.get(this.selectedRoleId).then(role => {
      this.boundRole = role;
      this.stepper.next();
    });
  }

  selectOrganisation(event: DataTableEvent) {
    this.selectedOrganisationId = event.row.OrganisationID;
    this.organisationService.get(this.selectedOrganisationId).then(organisation => {
      this.boundOrganisation = organisation;
      this.stepper.next();
    });
  }

  abort() {
    this.dialogRef.close();
  }

  save() {
    this.dialogRef.close({
      RoleID: this.selectedRoleId,
      OrganisationID: this.selectedOrganisationId
    });
  }

}
